<template>
  <SpecimenInfoTab :value="vegetativePlotDataSource" />
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import SpecimenInfoTab from '@/components/VegetativeMonitoring/PlotDetail/Tabs/SpecimenInfoTab'

  export default {
    components: {
      SpecimenInfoTab,
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
      vegetativePlotDataSource() {
        const data = this.currentFeatureDataSourceData(SOURCE_TYPES.vegetativeMonitoringEnvirodata)
        return data && data.plotData
      },
    },
  }
</script>